import { useToast } from "@/shared/hooks/useToast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { PiWarningFill, PiInfoFill   } from "react-icons/pi";
type ToasterProps = {
  position?: "top" | "bottom"
}

type IconProps = {
  variant: "success" | "destructive" | "default" | null | undefined
}

const Icon: React.FC<IconProps> = (
  { variant = "success"}
) => {
  switch (variant) {
    case "success":
      return <PiInfoFill className="text-4xl" />
    case "destructive":
      return <PiWarningFill  className="text-4xl" />
    default:
      return null
  }
}
  
export const Toaster: React.FC<ToasterProps> = (
  { position = "top" }
) => {
  const { toasts } = useToast()
  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex flex-row gap-2">
            <Icon variant={variant} />
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport position={position}  />
    </ToastProvider>
  )
}
